function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0144 2.38813L19.7422 1.64008C20.0859 1.27617 20.0859 0.790951 19.7422 0.457372L19.5097 0.214764C19.1963 -0.0986117 18.7011 -0.0581692 18.3674 0.265302L17.6295 0.993129L19.0144 2.38813ZM6.85363 13.4166L8.82487 12.5574L18.2663 3.12605L16.8814 1.76139L7.45011 11.1928L6.54029 13.0932C6.45943 13.265 6.66158 13.4976 6.85363 13.4166ZM3.17418 19.9671H15.0417C16.8612 19.9671 17.9125 18.9158 17.9125 16.8334V6.02726L16.2851 7.65473V16.7525C16.2851 17.8038 15.7189 18.3395 15.0215 18.3395H3.2045C2.19361 18.3395 1.62746 17.8038 1.62746 16.7525V5.2792C1.62746 4.2279 2.19361 3.68203 3.2045 3.68203H12.4135L14.0409 2.05454H3.17418C1.07154 2.05454 0 3.10583 0 5.18821V16.8334C0 18.9259 1.07154 19.9671 3.17418 19.9671Z",
  fill: "#823BEB"
});

function SvgGameEmailEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameEmailEdit);
export default __webpack_public_path__ + "static/media/game-email-edit.fc3a20fa.svg";
export { ForwardRef as ReactComponent };